import {internalApi} from "../../common/axios";
import {ShopPackageEntity} from "../storeManager/ShopPackageEntity";
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";

const fetchItemKrTextData = async () => {
    const {data} = await internalApi.get("auth/itemText");
    return data;
};

export const useItemKrTextData = () => {
    return useQueryBase('krItemTextData', fetchItemKrTextData);
}

const fetchBadgeItemData = async () => {
    const {data} = await internalApi.get("auth/badgeItemData");
    return data;
};

export const useBadgeItemData = () => {
    return useQueryBase('badgeItemData', fetchBadgeItemData);
}

const fetchKrTextData = async () => {
    const {data} = await internalApi.get("auth/text");
    return data;
}

export const useKrTextData = () => {
    return useQueryBase('krTextData', fetchKrTextData);
}

const fetchShopPackage = async () => {
    const {data} = await internalApi.get("auth/shopPackage");
    return data;
};

export const useShopPackage = () => {
    return useQueryBase('shopPackage', fetchShopPackage);
}

const updateShopPackage = async (shopPackage) => {
    const row = new ShopPackageEntity(shopPackage);
    if (row.isInvalidate()) return;
    await internalApi.post('store_manager/new', {data: row.toJson()});
};

export const useUpdateShopPackage = () => {
    return useMutationBase('shopPackage', updateShopPackage);
};

const fetchShopPackageGroup = async () => {
    const {data} = await internalApi.get("auth/shopPackageGroup");
    return data;
};

export const useShopPackageGroup = () => {
    return useQueryBase('shopPackageGroup', fetchShopPackageGroup);
}

const fetchPackageDataTable = async () => {
    const {data} = await internalApi.get('manager/analysis/package/table');
    return data.rows;
}

export const usePackageDataTable = () => {
    return useQueryBase('packageData', fetchPackageDataTable);
}

const fetchEventPlatterDataTable = async () => {
    const {data} = await internalApi.get('auth/eventPlatter');
    return data;
}

export const useEventPlatterData = () => {
    return useQueryBase('eventPlatterData', fetchEventPlatterDataTable);
}

const fetchShopDataTable = async () => {
    const {data} = await internalApi.get('auth/shopDataTable');
    return data;
}

export const useShopDataTable = () => {
    return useQueryBase('shopDataTable', fetchShopDataTable);
}

const fetchBookMainTBL = async () => {
    const {data} = await internalApi.get('auth/bookMainTBL');
    return data;
}

export const useBookMainTBL = () => {
    return useQueryBase('bookMainTBL', fetchBookMainTBL);
}